import React from 'react';
import { Shimmer } from '@uds/penders';

import { ShortcodeProps } from './';

export interface OuterProps {
  code?: ShortcodeProps;
}

// random % width for shimmer betwen 50% and 95%
const randomWidth = () => Math.floor(Math.random() * (95 - 50) + 50);

const PendingShortcode = ({ code }: OuterProps) => (
  <span
    style={{
      display: 'inline-block',
      width: `${randomWidth()}%`,
    }}
  >
    <Shimmer lines={code && code.elements ? 2 : 1} />
  </span>
);

PendingShortcode.displayName = 'PendingShortcode';

export default PendingShortcode;
